import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { MeterKind, MeterKindRequestBody } from './types';

export const meterKindsApi = createApi({
  reducerPath: 'meterKindsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/meter-kinds`,
  }),
  tagTypes: ['MeterKind', 'MeterKinds'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => ({
    getMeterKinds: builder.query<MeterKind[], void>({
      query: () => ({
        url: '/',
      }),
      providesTags: () => ['MeterKind', 'MeterKinds'],
    }),
    getMeterKindById: builder.query<MeterKind, string>({
      query: id => ({
        url: `/${id}`,
      }),
      providesTags: () => ['MeterKind'],
    }),
    createMeterKind: builder.mutation<MeterKind, MeterKindRequestBody>({
      query: data => ({
        url: '/',
        method: 'POST',
        data,
      }),
      invalidatesTags: result => [
        'MeterKind',
        { type: 'MeterKind', id: result?.id },
      ],
    }),
    updateMeterKind: builder.mutation<MeterKind, MeterKindRequestBody>({
      query: data => ({
        url: `/${data.id}`,
        method: 'PUT',
        data,
      }),
      invalidatesTags: result => [
        'MeterKind',
        { type: 'MeterKind', id: result?.id },
      ],
    }),
    deleteMeterKindById: builder.mutation<void, string>({
      query: id => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_, __, id) => ['MeterKind', { type: 'MeterKind', id }],
    }),
  }),
});

export const { useGetMeterKindsQuery } = meterKindsApi;
